var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"top-view-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"subtitle",domProps:{"innerHTML":_vm._s(_vm.subtitle)}}),_c('div',{staticClass:"infoText",domProps:{"innerHTML":_vm._s(_vm.infoText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }